<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-13 15:36:03
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-14 14:18:44
 * @FilePath: /partner.chaoyongtuan.com/src/modules/anchor/select.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<div class="drSearchSelect">
		<el-select class="multi" v-model="search_type" :placeholder="placeholder">
			<el-option v-for="(item, index) in searchTypeArr" :label="item.label" :value="item.value" :key="index"></el-option>
		</el-select>
		<dr-select
			class="dr-select"
			ref="drSelect"
			v-model="ids"
			v-bind="$attrs"
			v-on="$listeners"
			:search_type="search_type"
			:platformId="platformId"
			is-team
			:multiple-limit="multipleLimit"
			multiple
			collapse-tags
			:returnType="returnType"
			placehoder="请选择/搜索最多10个达人"
		/>
	</div>
</template>
<script>
import drSelect from '@/components/drSelect';
import { PLATFORM_DY, PLATFORM_KS } from '@/utils/dataMap';
const confs = {
	[PLATFORM_DY.value]: [
		{ label: '搜昵称', value: '1' },
		{ label: '搜抖音号', value: '2' },
	],
	[PLATFORM_KS.value]: [
		{ label: '搜昵称', value: '1' },
		{ label: '搜快手号/ID', value: '2' },
	],
};
export default {
	name: 'drSearchSelect',
	components: {
		drSelect,
	},
	props: {
		value: [String, Number, Array],
		platformId: {
			type: [String, Number],
			default: '',
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
		multipleLimit: {
			type: [String, Number],
			default: 10,
		},
		returnType: {
			type: String,
			default: 'id',
		},
	},
	data() {
		return {
			search_type: '1',
			ids: this.value,
		};
	},
	watch: {
		value(val) {
			this.ids = val;
		},
	},
	computed: {
		searchTypeArr() {
			return confs[+this.platformId];
		},
	},
	methods: {
		reset() {
			Object.assign(this.$data, this.$options.data());
		},
	},
};
</script>
<style lang='less' scoped>
.drSearchSelect {
	display: flex;
	align-items: center;
	.multi {
		/deep/ .el-input {
			width: 120px;
		}
		/deep/ .el-input__inner {
			border-right: none;
			border-color: #e3e3e3;
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}
	}
	.dr-select {
		flex: 1;
		/deep/ .el-input__inner {
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
		}
	}
	/deep/ .el-input__inner {
		border-radius: 0px;
	}
	/deep/ .input-with-select .el-input-group__prepend {
		background-color: #fff;
	}
}
</style>